export default __webpack_public_path__ + "0550e323f550149b35366a8ad42450cb.png";